<script>
import { toast } from "@zerodevx/svelte-toast";
import { restoreSavedPrompt } from "@app/store/savedPromptStore.svelte.js";
import * as m from "@app/paraglide/messages.js";

/* toastId is sent by svelte-toast (sendIdTo). */
let { prompt, toastId } = $props();

function undo() {
    restoreSavedPrompt(prompt);
    toast.pop(toastId);
}
</script>

<div class="d-flex align-items-center gap-2">
    <span>{m.assistant_saved_prompt_removed()}</span>
    <button type="button" class="btn btn-sm btn-light ms-auto py-0" onclick={undo}>{m.assistant_saved_prompt_undo()}</button>
</div>
